import api from './api';

const ubicacionService = {
    // Obtener todas las ubicaciones
    getUbicaciones: async () => {
        const response = await api.get('/api/ubicaciones');
        return response.data;
    },

    // Obtener una ubicación por número
    getUbicacion: async (nroUbicacion: number) => {
        const response = await api.get(`/api/ubicaciones/${nroUbicacion}`);
        return response.data;
    }
};

export default ubicacionService; 